module.exports = __webpack_public_path__ + "static/pinkbearsuitcase-e43f44cb806089334fa27d40a38feaad.jpeg";